import React from 'react';
import { FilterItem } from './filter-item';

interface Props {
  label: string;
  groupName: string;
  items: [string, string][];
  onChange: (groupName: string, key: string) => () => void;
  selected: string[];
}
export function FilterGroup({ label, groupName, items, selected, onChange }: Props) {
  return (
    <fieldset className="form-group">
      <legend>{label}</legend>
      {items.map(([key, value]) => (
        <FilterItem
          id={key}
          label={value}
          groupName={groupName}
          checked={selected.includes(key)}
          onCheck={onChange(groupName, key)}
        />
      ))}
    </fieldset>
  );
}
